export const VIEW_PERSONAL_DATA = 'view_personal_data';
export const EDIT_LOYALTY_DATA = 'edit_loyalty_data';
